import React from 'react';
import { 
  OfficeImg, 
  PrimaryLookImg, 
  IconLogoImg, 
  AgregatorLogoImg, 
  PlatformLogoImg, 
  RoomLogoImg, 
  PammLogoImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
  Description 
} from '@Main/elements';
import { DownloadFile, P, Margin } from '@helpers';
import { getImage } from "gatsby-plugin-image"



export const LogoPageInverse = ({getPng, getZip, t}) => {

    return (
      <PageWrapper darkMode={false}>
        <FlexDiv>
          <OfficeImg image={getImage(getPng("office"))} alt="office"/>
          <Text width='350px' marginLeft='30px' marginTop='300px' paddingBefforeText="45px">
            <h1>{t("Logo color inversion")}</h1>
            <p>
              {t("If the company logo is required to be placed on a white or light-colored background, logo inversion is used to preserve legibility.")}
            </p>
          </Text>
        </FlexDiv>
        <Container paddingTop='130px' marginLeft='102px' border={true} marginRight='57px' paddingBottom='120px'>
          <P weight='400' size='25px' height='20px'>{t("Applying the inverted color logo")}</P>
          <FlexDiv>
            <Text width='308px' paddingAffterText="20px" paddingBefforeText="45px">
              <p>
                {t("A logo with inverted colors can be used in the same situations as a standard logo if the color palette of media and other platforms requires it.")}
              </p>
              <DownloadFile fileName='primary_logo_inversion' file={getZip("primary_logo_inversion")}/>
            </Text>
            <PrimaryLookImg />
          </FlexDiv>
        </Container>
        <Container paddingTop='120px' marginLeft='102px' border={true} marginRight='57px' paddingBottom='120px'>
          <P weight='400' size='25px' height='20px'>{t("The petal icon color inversion")}</P>
          <FlexDiv>
            <Text width='355px' paddingAffterText="20px" paddingBefforeText="45px">
              <p>
                {t("If the isolated petal icon is required to be placed on a white or light-colored background, inversion is used to preserve legibility.")}
              </p>
              <DownloadFile fileName='icon_logo_inversion' file={getZip("icon_logo_inversion")}/>
            </Text>
            <IconLogoImg />
          </FlexDiv>
        </Container>
        <Container paddingTop='120px' marginLeft='102px' marginRight='57px' paddingBottom='130px'>
          <P weight='400' size='25px' height='20px'>{t("Additional logo colors inversion")}</P>
          <FlexDiv>
            <div>
              <Text width='308px' paddingAffterText="20px" paddingBefforeText="45px">
                <p>
                  {t("If the logo is used in media describing specific Soft-FX products, inversion of the logo font color can also be applied. Please note that this is only applicable to specific products presented below.")}
                </p>
              </Text>
              <Margin marginTop="70px" marginBottom="10px">
                <DownloadFile fileName='liquidity_agregator_logo_inversion' file={getZip("liquidity_agregator_logo_inversion")}/>
              </Margin>
              <DownloadFile fileName='trading_platform_logo_inversion' file={getZip("trading_platform_logo_inversion")}/>
              <DownloadFile fileName='traders_room_logo_inversion' file={getZip("traders_room_logo_inversion")}/>
              <DownloadFile fileName='pamm_logo_inversion' file={getZip("pamm_logo_inversion")}/>
            </div>
            <div>
              <Description marginTop='50px' marginLeft='168px'>
                <AgregatorLogoImg />
                <p>{t("TickTrader Liquidity Agregator")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='168px'>
                <PlatformLogoImg />
                <p>{t("TickTrader Trading Platform")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='168px'>
                <RoomLogoImg />
                <p>{t("TickTrader Traders Room")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='168px'>
                <PammLogoImg />
                <p>{t("TickTrader PAMM")}</p>
              </Description>
            </div>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
